module.exports = __webpack_public_path__ + "img/loyalty-program-icon.454a337a.svg";